<template>
  <div class="tj-container">
    <div class="layout-wrapper" :style="scaleStyle">
      <div class="left-wrapper">
        <AsideMenu v-model="activeMenu" />
        <div class="nav-content">
          <!--渐变-->
          <div class="bg-gradient"></div>
          <!-- 基础 -->
          <template v-if="activeMenu === 1">
            <Base :dataSource="dataSource.base.character" :styleData="currentStyle"/>
            <Skill :dataSource="dataSource.base.skill" :notes="notes" :currentStyle="currentStyle"/>
          </template>
          <!-- 档案 -->
          <template v-if="activeMenu === 2">
            <Attr :dataSource="dataSource.base.attr" :characterDataSource="dataSource.base.character"/>
            <Team :dataSource="dataSource.base.force"/>
          </template>
          <!-- 语音 -->
          <template v-if="activeMenu === 3">
            <Voice
              :key="currentStyle.key"
              :dataSource="currentStyle.voices"
              :styleData="currentStyle"
              :lhDataSource="currentStyle.lh"
              :baseCharacter="dataSource.base.character"
            />
          </template>
          <!--好感度-->
          <template v-if="activeMenu === 4">
            <Conversation :dataSource="dataSource.base.conversation" :styleData="currentStyle"/>
          </template>
          <!-- 视频 -->
          <template v-if="activeMenu === 5">
            <Videos :dataSource="dataSource.base.videos"/>
          </template>
        </div>
      </div>
      <div :class="[['1', '2', '3', '4'].includes(showType) ? 'right-wrapper-box' : 'right-wrapper']">
        <!--<div v-if="isShowLimit" class="limit-box">
          <div class="border l-top"></div>
          <div class="border r-top"></div>
          <div class="border r-bottom"></div>
          <div class="border l-bottom"></div>
          <div class="inner-box">
            <div class="tip">GAMEKEE健康系统提示你，根据相关规定 <br />您需要实名认证后才能继续浏览。</div>
            <div class="btn" @click="handleVerify">{{ loginUid ? "立即实名" : "立即登录" }}</div>
          </div>
        </div> -->
        <div class="live2d-box" v-if="!['1', '2', '3', '4'].includes(showType)">
          <!-- 全身 -->
          <Live2d
            @onPublish="handlePublish"
            v-if="showType == '0_0'"
            :key="currentStyle.key"
            :dataSource="currentStyle.live2d.full"
            type="full"
            :operationType="operationType"
            animation="idle"
          />
          <!-- live2d -->
          <Live2d
            @onPublish="handlePublish"
            v-if="showType == '0_1'"
            :key="currentStyle.key"
            :dataSource="currentStyle.live2d.cover"
            type="cover"
            :operationType="operationType"
            animation="cover_idle"
          />
          <!-- 瞄准 -->
          <Live2d
            @onPublish="handlePublish"
            v-if="showType == '0_2'"
            :key="currentStyle.key"
            :dataSource="currentStyle.live2d.aim"
            type="aim"
            :operationType="operationType"
            animation="aim_idle"
          />
        </div>
        <div class="other-box" v-else>
          <!-- 立绘 -->
          <LH v-if="showType == '1'" :key="currentStyle.key" :dataSource="currentStyle.lh"/>
          <!-- 语音 -->
          <Voice
            v-if="showType == '2'"
            :key="currentStyle.key"
            :dataSource="currentStyle.voices"
            :lhDataSource="currentStyle.lh"
          />
          <!-- sd模型 -->
          <SDModel v-if="showType == '3'" :key="currentStyle.key" :dataSource="currentStyle.SDModel"/>
          <!-- 大招动画 -->
          <Dzdh v-if="showType == '4'" :key="currentStyle.key" :dataSource="currentStyle.dzdh"/>
        </div>
      </div>
      <slot name="nikkeAside"></slot>
      <!-- 切换选项 -->
      <SwitchOptions
        :currentStyle="currentStyle"
        :dataSource="dataSource.style"
        :operationType="operationType"
        @handleSwitch="handleSwitch"
        @switchStyle="switchStyle"
        @handleOpt="handleOpt"
      />
      <ChangeLive2dPosition v-if="isShowPosition"/>
      <ChangeSkin :dataSource="dataSource.style" @switchSkin="switchStyle" :flag="changePosition"/>
    </div>

    <!-- 分享弹窗 -->
    <ShareView
      ref="shareView"
      :detail="detail"
      :user="detail.user"
      :dataSource="dataSource"
      :currentStyle="currentStyle"
      :notes="notes"
      :activeMenu="activeMenu"
      :operationType="operationType"
    />
    <Live2dDialog ref="live2dDialog"/>
  </div>
</template>

<script>
import SwitchOptions from "./components/switch.vue";
import Live2d from "./components/live2d.vue";
import LH from "./components/lh.vue";
import Voice from "./components/voice.vue";
import SDModel from "./components/sdModel.vue";
import Dzdh from "./components/dzdh.vue";
import Slogan from "./components/slogan.vue";
import Base from "./components/base.vue";
import Skill from "./components/skill.vue";
import Attr from "./components/attr.vue";
import Team from "./components/team.vue";
import Conversation from "./components/conversation.vue";
import Videos from "./components/videos.vue";
import ShareView from "./shareView.vue";
import SkinEvalution from "./components/skinEvalution.vue";
import AsideMenu from "./components/AsideMenu.vue";
import ChangeSkin from "./components/changeSkin.vue";
import Live2dDialog from "./components/Live2dDialog.vue";
import ChangeLive2dPosition from "../components/ChangeLive2dPosition.vue";
// entry
import {entry} from "../entry.js";
import {mapGetters} from "vuex";
// formatData
import {formatData} from "../utils.js";
import eventBus from "@/plugins/eventBus";

// api
import {apiContentEdit} from "@/api/contentApi";

const entryMap = JSON.parse(JSON.stringify(entry));
export default {
  name: "WikiNikkeTJ",
  props: {
    isShowLimit: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return {
          content_json: "",
          entry_data_bind: []
        };
      }
    }
  },
  components: {
    SwitchOptions,
    Live2d,
    LH,
    Voice,
    SDModel,
    Dzdh,
    Slogan,
    Base,
    Skill,
    Attr,
    Team,
    Conversation,
    Videos,
    ShareView,
    SkinEvalution,
    AsideMenu,
    ChangeSkin,
    Live2dDialog,
    ChangeLive2dPosition
  },
  data() {
    return {
      scaleStyle: {},
      hasHistory: true,
      activeMenu: 1,
      dataSource: entryMap,
      currentStyle: {key: "style1", ...entryMap.style.style1},
      notes: [],
      isShowPosition: false,
      asideBarStyle: {},
      showType: "0_0",
      live2dVisible: false,
      position: null,
      operationType: 0, // 0 放大， 1缩小
      currentSkinIndex: 0
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUid"]),
    changePosition() {
      return ["1", "2", "3", "4"].includes(this.showType);
    }
  },
  watch: {
    detail: {
      handler(val) {
        if (!val.content_json) return;
        const dataSource = formatData(val.content_json, val.entry_data_bind, entryMap);
        this.dataSource = dataSource;
        this.currentStyle = {key: "style1", ...this.dataSource.style["style1"]};
        this.notes = Object.keys(dataSource.base.notes)
          .filter(key => {
            return dataSource.base.notes[key].label.value && dataSource.base.notes[key].label.hasValue;
          })
          .map((key, index) => {
            return {
              label: dataSource.base.notes[key].label.value,
              value: dataSource.base.notes[key].value.value
            };
          });
      },
      // deep: true,
      immediate: true
    }
  },
  mounted() {
    eventBus.$on("live2dPosition", this.handleShowPosition);
    setTimeout(() => {
      this.resizeScale();
      window.addEventListener("resize", () => {
        this.resizeScale();
      });
    }, 200);
  },
  deactivated() {
    document.getElementsByClassName('zsca-wiki-home')[0].style.paddingTop = '10px'
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeScale);
    eventBus.$off("live2dPosition");
    document.getElementsByClassName('zsca-wiki-home')[0].style.paddingTop = '10px'
  },
  beforeMount() {
    window.devicePixelRatio =  1;
  },
  methods: {
    handleVerify() {
      this.$emit("handleVerify");
    },
    switchStyle(key, index) {
      this.currentStyle = {key, ...this.dataSource.style[key]};
      if (index) {
        this.currentSkinIndex = index;
        this.isShowPosition = false;
      }
    },
    handleShowPosition() {
      this.isShowPosition = !this.isShowPosition;
    },
    handleSwitch(type) {
      this.showType = type;
    },
    handleOpt(type) {
      if (type === "query") {
        this.$refs.live2dDialog.open(this.currentStyle, this.showType, this.dataSource.base.character.name.value);
        return;
      }

      this.operationType = type;
    },
    /**
     * @param position
     * @param type
     */
    async handlePublish(data) {
      // 未登录
      if (!this.isLoginShow()) return;

      let content_json = JSON.parse(this.detail.content_json);
      const bindData = JSON.parse(JSON.stringify(this.detail.entry_data_bind));
      const currentStyle = this.currentStyle;
      console.log(currentStyle);
      const live2dSource = currentStyle.live2d[data.live2dType].source;
      const position = live2dSource.value.position || {pc: {}};
      const currentPostionObj = {
        [data.type]: data.position
      };
      const sourcePositionObj = position.pc;
      const live2dSourceValue = {
        ...live2dSource.value,
        position: {
          ...position,
          pc: {
            ...sourcePositionObj,
            ...currentPostionObj
          }
        }
      };

      const live2dKey = live2dSource.key;
      const tableCellKey = bindData[live2dKey];

      const object = content_json.styleData[this.currentSkinIndex].data.flat().find(({key}) => key === tableCellKey);
      // 赋值
      if (object) object.value = live2dSourceValue;
      console.log(content_json, object);

      const params = {
        content_json: JSON.stringify(content_json),
        editor_type: this.detail.editor_type,
        entry_id: this.detail.entry_id,
        entry_role: this.detailentry_role || {},
        id: this.detail.id,
        limit_age: this.detail.limit_age,
        summary: this.detail.summary,
        title: this.detail.title,
        type: this.detail.type
      };
      const res = await apiContentEdit(params);
      if (res.code === 0) {
        this.$message.success("保存成功");
        window.location.reload();
      }
    },
    hasVideos(object) {
      return Object.values(object).some(({source}) => Boolean(source.value));
    },
    hasEvalution(obj) {
      return Object.keys(obj).some(key => {
        return obj[key].link.hasValue && obj[key].link.value;
      });
    },
    hasConversation(obj) {
      return Object.keys(obj).some(key => {
        return obj[key].question.hasValue && obj[key].question.value;
      });
    },
    resizeScale() {
      document.body.style.minWidth = "1280px";
      // document.body.style.minHeight = "911px";
      const width = document.body.clientWidth;
      const height = document.body.clientHeight;
      const baseWidth = 1692;
      const baseHeight = height < 911 ? 911 : height;
      if (width < baseWidth) {
        const scale = width / baseWidth;
        this.scaleStyle = {
          transform: `translate(${(width - baseWidth) / 2}px,${(baseHeight * scale - baseHeight) /
          2}px) scale(${scale})`
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tj-container {
  position: relative;
  z-index: 1;
  white-space: pre-wrap;
  word-break: break-all;
  word-wrap: break-word;
  width: 100%;
  height: 911px;
  min-height: 100vh;
  overflow: hidden;
  .layout-wrapper {
    position: relative;
    display: flex;
    padding-left: 22px;
    height: 100%;
    width: 1692px;
    margin: 0 auto;
    padding-top: 100px;
  }

  .left-wrapper {
    height: 1920px;
    flex-shrink: 0;
    position: relative;
    width: 660px;
    z-index: 2;
    display: flex;
    column-gap: 36px;

    .nav-content {
      position: relative;
      display: flex;
      flex-direction: column;
      row-gap: 25px;

      .bg-gradient {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 660px;
        height: 100%;
        background: linear-gradient(90deg,
        rgba(241, 241, 243, 0) 0%,
        rgba(241, 241, 243, 0) 10%,
        rgba(241, 241, 243, 1) 11%,
        rgba(241, 241, 243, 1) 60%,
        rgba(241, 241, 243, 0) 100%);
      }
    }
  }

  .right-wrapper {
    height: 1920px;
    flex-shrink: 0;
    width: 2560px;
    z-index: 1;
    position: relative;
    margin-top: -100px;
    margin-left: -490px;

    .live2d-box {
      width: 100%;
      height: 1600px;

      &:after {
        position: absolute;
        width: 1300px;
        right: 0;
        top: 0;
        height: 100%;
        content: "";
        display: block;
        background: linear-gradient(90deg, rgba(241, 241, 243, 0) 0%, rgba(241, 241, 243, 0.6) 10%,rgba(241, 241, 243, 0.9) 15%, #f1f1f3 21%, #f1f1f3 100%);
      }
    }

    .other-box {
      width: 65%;
      height: 100%;
    }
  }

  .right-wrapper-box {
    width: calc(100% - 460px);
    z-index: 1;
    position: relative;
    margin-top: -50px;
    display: flex;
    justify-content: center;

    .other-box {
      //width: 100%;
      height: 100%;
    }
  }
}
</style>
